import { DatePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GoogleLoginProvider, SocialLoginModule, SocialAuthServiceConfig } from '@abacritt/angularx-social-login';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { AppRoutingModule } from './app-routing.module';
import { AppSharedModule } from './app-shared.module';
import { AppComponent } from './app.component';
import { AuthGuard } from './auth/auth.guard';
import { authTokenInterceptorProvider } from './auth/interceptor/auth.token.interceptor';
import { TimezoneInterceptorProvider } from './auth/interceptor/timezone.interceptor';
import { LoginComponent } from './auth/login/login.component';
import { OfficeTimePipe } from './common/pipes/officeTime.pipe';
import { OfficeTimeFormPipe } from './common/pipes/officeTimeForm.pipe';
import { StaleChunkRecoveryService } from './routes/stale-chunk-recovery.service';
import { HomePageComponent } from './home-page/home-page.component';
import { InterceptorService } from './services/interceptor.service';

/**
 * App shell. Shared components, pipes and third-party UI modules live in AppSharedModule;
 * entity features are lazy-loaded from routes/lazy/ (see routes/lazy-features.ts).
 *
 * Login and home stay declared here because they use the Google sign-in button, and
 * SocialLoginModule registers SocialAuthService — importing it anywhere a lazy module can reach
 * would give that module its own, unconfigured auth service.
 */
@NgModule({
  declarations: [AppComponent, LoginComponent, HomePageComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    SocialLoginModule,
    AppSharedModule,
    AppRoutingModule,
  ],
  providers: [
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: true, //keeps the user signed in
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              '643251371111-jeinp9e8sj1nth7hn38gjqleu6vneqh8.apps.googleusercontent.com', // your client id
              {
                scopes: [
                  'openid',
                  'email',
                  'profile'
                ],
                oneTapEnabled: false
              }
            ),
          },
        ],
        onError: (err) => {
          console.error('SocialAuthServiceConfig ', err);
        }
      } as SocialAuthServiceConfig,
    },
    authTokenInterceptorProvider,
    TimezoneInterceptorProvider,
    AuthGuard,
    DatePipe,
    OfficeTimePipe,
    OfficeTimeFormPipe,
    MessageService,
    InterceptorService,
    Title,
    ConfirmationService,
    DialogService,
    // Reloads tabs left open across a deploy when a lazy entity chunk no longer exists.
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: (recovery: StaleChunkRecoveryService) => () => recovery.start(),
      deps: [StaleChunkRecoveryService],
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {}
